import { Gender } from '../../common/enums/gender.enum'
import { LinkType } from '../../common/enums/link-type.enum'
import { YieldType } from '../../common/enums/yield-type.enum'
import { ResourceDefinition } from '../../common/interfaces/resource-definition.interface'
import { ProjectStatus } from './project-status.enum'
import { Project } from './project.interface'

export const projectOwnOnlyDefinition: ResourceDefinition = {
  title: 'Mes missions',
  nameSingular: 'mission',
  namePlural: 'missions',
  hasDetailPage: true,
  hasListPage: true,
  gender: Gender.Feminine,
  slug: 'projects',
  path: 'missions',
  buttons: [LinkType.CREATE, LinkType.EXPORT],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [
    {
      propName: 'plannedWorkCount',
      preventDeleteMessage: `Certains plannings dépendent de cette mission`
    },
    {
      propName: 'timeSheetCount',
      preventDeleteMessage: `Certaines timesheets dépendent de cette mission`
    },
    {
      propName: 'invoiceCount',
      preventDeleteMessage: `Une ou plusieurs factures sont reliées à ce projet`
    }
  ],
  actionButtons: [],
  dropdownLinks: [
    {
      type: LinkType.DETAIL,
      permission: 'readProjects'
    },
    {
      type: LinkType.EDIT,
      permission: 'editProjects'
    },
    {
      type: LinkType.DUPLICATE,
      permission: 'addProjects'
    },
    {
      type: LinkType.DELETE,
      permission: 'deleteProjects'
    }
  ],
  yields: [
    {
      label: 'Mission (N° - Référence)',
      property: 'department.color',
      className: 'has-mini-circle',
      secondProperty: 'label',
      orderByProperty: 'name',
      type: YieldType.Color
    },
    {
      label: 'Client',
      property: 'customer.name',
      link: (project: Project) =>
        project.customer ? `clients/${project.customer.id}` : null
    },
    {
      label: 'Res mission',
      property: 'referent.name'
    },
    {
      label: 'Equipe projet',
      property: 'team',
      type: YieldType.Image,
      disableOrderBy: true
    },
    {
      label: 'Statut',
      property: 'status',
      type: YieldType.ProgressBar
    }
  ]
}
